import _ from 'lodash'

const transformForSave = (configuration, prevConfiguration = {}) => {
  const _action_steps = markActionSteps(configuration.action_steps, prevConfiguration.action_steps)
  const _additional_fields = markAdditionalFields(
    configuration.additional_fields,
    prevConfiguration.additional_fields
  )
  const data = {
    active: configuration.active,
    entity_id: configuration.entity_id,
    account_id: configuration.account_id,
    user_id: configuration.user_id,
    manager_ids: configuration.managerIds,
    manager_template_ids: configuration.managerTemplateIds,
    hold_time: configuration.holdTime,
    unit_time: configuration.unitTime,
    action_status: configuration.action_step_statuses,
    optional_status: configuration.additional_criteria,
    additional_fields: _additional_fields,
    action_steps: _action_steps,
    limit_reservable: configuration.limitReservable,
  }

  return data
}

export {transformForSave}

const markActionSteps = (action_steps, prev_action_steps) => {
  let _action_steps = _.cloneDeep(action_steps)
  // add delete markers for action steps
  let deleted_action_steps = []
  if (prev_action_steps.length > 0) {
    deleted_action_steps = _.differenceBy(prev_action_steps, _action_steps, 'action_id').map(s => ({
      ...s,
      is_deleted: true,
    }))
  }
  // add markers for edited
  // add markers for new items
  if (prev_action_steps.length > 0) {
    _action_steps = _.map(_action_steps, s => {
      // search changed step
      const pstep = _.find(
        prev_action_steps,
        ps =>
          ps.action_id === s.action_id &&
          !_.isEqual(ps.return_field_data?.id, s.return_field_data?.id)
      )

      if (pstep) {
        s.is_edited = true
      }

      // for add
      const nstep = _.find(prev_action_steps, ps => ps.action_id === s.action_id)
      if (!nstep) {
        s.is_new = true
      }

      return s
    })
  }

  return [..._action_steps, ...deleted_action_steps]
}

const markAdditionalFields = (additional_fields, prev_additional_fields) => {
  let _additional_fields = _.cloneDeep(additional_fields)
  // add delete markers for additional fields
  let deleted_additional_fields = []
  if (prev_additional_fields.length > 0) {
    deleted_additional_fields = _.differenceBy(
      prev_additional_fields,
      _additional_fields,
      'id'
    ).map(f => ({
      ...f,
      is_deleted: true,
    }))
  }
  // add markers for edited
  if (prev_additional_fields.length > 0) {
    _additional_fields = _.map(_additional_fields, f => {
      // search changed step
      const pfield = _.find(prev_additional_fields, pf => pf.id === f.id && !_.isEqual(pf, f))

      if (pfield) {
        f.is_edited = true
      }
      return f
    })
  }

  return [..._additional_fields, ...deleted_additional_fields]
}
